import { render, staticRenderFns } from "./IFieldBoolean.vue?vue&type=template&id=1a82d420&"
import script from "./IFieldBoolean.vue?vue&type=script&lang=js&"
export * from "./IFieldBoolean.vue?vue&type=script&lang=js&"
import style0 from "./IFieldBoolean.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QToggle});
